import React, { useEffect, useState } from 'react'
import DateConverter from '../Tools/DateConverter';
import MsgUtils from '../Tools/MsgUtils';
import UtilsFac from '../Tools/UtilsFacturasSeguimiento';
import ModalCargando from '../utilsComponentes/ModalCargando';
import UtilsBufer from '../Tools/UtilsBufer';
const server = process.env.REACT_APP_SERVER;

function DetallePedido(props) {
    const { info, sucursal } = props;
    const [seguimiento, setSeguimiento] = useState([]);
    const [loading,setLoading] = useState(false);
    const getDiferencia=(dato,indice)=>{
        var horaIni = new Date(seguimiento[indice].HORA).getTime();
        var horaFin = new Date(dato.HORA).getTime();
        return Math.round((horaFin-horaIni)/(1000*60));
    }
    const getColor=(dato,indice)=>{
        var valor = getDiferencia(dato,indice);
        if(valor<4){
            return "#2EFE2E";
        }else if(valor>4 && valor<9){
            return "#F7FE2E";
        }else{
            return "#FF0000";
        }
    }
    useEffect(() => {
        setLoading(true);
        fetch(`${server}/reporte/getMotosSeguimiento`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(
                { info, sucursal }
            )
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    console.log(data.ok)
                    setSeguimiento(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
                setLoading(false);
            })
            .catch(err => console.log(err));
    }, [])
    return (
        <div className='container-fluid overflow-auto' style={{ height: "90hv" }}>
            <ModalCargando show={loading} />
            <table className="table table-sm table-dark table-striped table-hover">
                <thead>
                    <tr className='text-center'>
                        <th className="col-4">Tipo</th>
                        <th className="col-5">Nombre</th>
                        <th className="col-1">Hora</th>
                        <th className="col-2">Tiempo</th>
                    </tr>
                </thead>
                <tbody>
                    {seguimiento.map((item, index) => {
                        return (
                            <tr className='text-center' key={index}>
                                <td className='text-start'>{UtilsFac.getTipo(item.TIPO)}</td>
                                <td className='text-start'>
                                    <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                        {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                        <div className='ps-2 my-auto d-none d-sm-inline'>
                                            <div className="cargoHeader fw-bold">{item.NOMBREX}</div>
                                            <div className='cargoHeader '>{item.CARGO}</div>
                                        </div>
                                    </div>
                                </td>
                                <th scope="row">{DateConverter.formatoHora(item.HORA)}</th>
                                <td>
                                    {index!=0&&
                                        <div className='container-fluid m-0 p-0'>
                                            <div className='row row-cols-2 g-0'>
                                                <div className='col-6'>
                                                    <div className='container-fluid m-0 p-0'>
                                                        <i className="fa-solid fa-square-up-right fa-flip-horizontal fa-xl"></i>
                                                    </div>
                                                    <div className='container-fluid'>
                                                        <i className="fa-solid fa-square-caret-left fa-xl"></i>
                                                    </div>
                                                </div>
                                                <div className='col-6 my-auto'>
                                                    <div className='container-fluid rounded text-dark' style={{background:`${getColor(item,index-1)}`}}>
                                                        {getDiferencia(item,index-1)} min
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default DetallePedido
